import { MapAsync } from "../async/MapAsync"
import type { NetworkProgress, NetworkTrackingCallback } from "../types/Network"
import { ResponseContentLength } from "./ResponseContentLength"
import { StreamCreate } from "./StreamCreate"
import { StreamToIterable } from "./StreamToIterable"

export const ProgressFetch = (
  url: string,
  init: RequestInit = {},
  { download }: Omit<NetworkProgress, "upload"> = {}
): Promise<Response> => fetch(url, init).then(r => trackResponse(r, download))

function trackStream(
  sourceStream: ReadableStream<Uint8Array>,
  progress: NetworkTrackingCallback,
  cancel: () => void,
  content_length?: number
): ReadableStream<Uint8Array> {
  let done = 0

  const send = () => progress({ done, total: content_length ?? done })

  void send()

  return StreamCreate(
    MapAsync((value: Uint8Array) => {
      done += value.byteLength
      void send()
      return value
    }, StreamToIterable(sourceStream)),
    cancel
  )
}

function trackResponse(
  response: Response,
  progress?: NetworkTrackingCallback
): Response {
  if (!progress || !response.body) return response

  return new Response(
    trackStream(
      response.body,
      progress,
      () => response.body!.cancel(),
      ResponseContentLength(response)
    ),
    {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
    }
  )
}
